let dispose;

function initializeHeader() {
  dispose?.();
  const header = document.querySelector('[data-header-custom]');
  if (!header) return;
  const wrapper = header.closest('.page-wrapper');
  const controller = new AbortController();
  let frame = 0;

  const update = () => {
    frame = 0;
    const wrapperScrolls = wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY);
    const offset = wrapperScrolls ? wrapper.scrollTop : window.scrollY;
    header.toggleAttribute('data-scrolled', offset > 0);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  const options = { passive: true, signal: controller.signal };
  wrapper?.addEventListener('scroll', schedule, options);
  window.addEventListener('scroll', schedule, options);
  window.addEventListener('resize', schedule, options);
  window.addEventListener('pageshow', schedule, options);
  update();
  dispose = () => {
    controller.abort();
    cancelAnimationFrame(frame);
  };
}

initializeHeader();
document.addEventListener('shopify:section:load', initializeHeader);
document.addEventListener('shopify:section:unload', initializeHeader);
